import { apiClient } from '@/api/api-client';
import { MediaAsset, MediaFolder, MediaInput } from '@/types/media';
import exp from 'constants';

export async function getMediaList(parentId: string | null, query?: string | null) {
    const url = parentId ? `/mediaassets?parentId=${parentId}` : `/mediaassets`;
    const finalUrl = query ? `${url}?q=${query}` : url;
    const response = await apiClient.get<MediaAsset[], {}>(finalUrl, {});
    return response;
}

export async function storeMedia(input: MediaInput) {
    const response = await apiClient.post<MediaAsset, MediaInput>(`/mediaassets`, input);
    return response;
}


export async function getMediaFolders(parentId: string | null) {
    const url = parentId ? `/mediaassets/folders?parentId=${parentId}` : `/mediaassets/folders`;
    const response = await apiClient.get<MediaFolder[], {}>(url, {});
    return response;
}

export async function createNewFolder(parentId: string | null, folderNaame: string, path: string) {
    const url = parentId ? `/mediaassets/folders?parentId=${parentId}` : `/mediaassets/folders`;
    const response = await apiClient.post<MediaFolder, {}>(url, { name: folderNaame, parentId: parentId, path: path });
    return response;
}

export async function deleteFolder(id: string) {
    const url = `/mediaassets/folders/${id}/delete`;
    const response = await apiClient.post<{}, {}>(url);
    return response;
}

export async function deleteMedia(id: string) {
    const url = `/mediaassets/${id}`;
    const response = await apiClient.delete<{}>(url);
    return response;
}